require('./Foundation/Image/Editor.js')
